export default "__VITE_ASSET__BPNJsOI1__"